import styled from "styled-components";

import RefSelectInput from "./RefSelectInput";

export const StyledPhoneTypeAndNumber = styled.div`
    padding-bottom: 4px;
    display: flex;
`;

export const StyledPhoneType = styled(RefSelectInput)`
    margin-right: 10px;
    max-width: 85px;
`;
